import { useState } from "react";
import {
    Box,
    Typography,
    TextField,
    FormControlLabel,
    Checkbox,
    Radio,
    RadioGroup,
    FormControl,
    FormLabel,
    Button,
    FormGroup,
    Modal,
} from "@mui/material";
import { FaBuilding, FaCalendarAlt, FaPhone, FaPhoneAlt, FaUser } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
import { toast } from "react-toastify";
import { MdEmail, MdOutlineAccessTimeFilled } from "react-icons/md";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import { IoClose } from "react-icons/io5";

export const NilCollaborationForm = ({ openRequest, setOpenRequest }) => {
    
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        companyName: "",
        individualName: "",
        businessAddress: "",
        businessPhone: "",
        requestedDate: "",
        alternateDate: "",
        additionalDetails: "",
        userEmail: "",
        phoneNo: "",
        streetAddress: "",
        addressLineTwo: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        hoursRequested: 0
    });
    

    const options = [
        "Autographs & Appearances",
        "Merchandise & Apparel",
        "Social media",
        "Television/Radio Ads",
        "Gaming",
        "Print Materials",
        "Website Content",
        "Other"
    ];
    const [selectedOption, setSelectedOption] = useState("");
    const [otherText, setOtherText] = useState("");
    const [selectedPaymentOption, setSelectedPaymentOption] = useState("");
    const [paymentDetails, setPaymentDetails] = useState({
        flatFeeAmount: "",
        royaltyPercentage: "",
        otherPaymentDescription: ""
    });
    const [isAcknowledged, setIsAcknowledged] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleOptionChange = (option) => {
        setSelectedOption(option);
        if (option !== "Other") setOtherText("");
    };

    const handlePaymentOptionChange = (option) => {
        setSelectedPaymentOption(option);
        setPaymentDetails({ flatFeeAmount: "", royaltyPercentage: "", otherPaymentDescription: "" });
    };

    const handlePaymentInputChange = (e) => {
        const { value } = e.target;
        if (selectedPaymentOption === "Flat Fee") {
            setPaymentDetails(prev => ({ ...prev, flatFeeAmount: value }));
        } else if (selectedPaymentOption === "Royalties") {
            setPaymentDetails(prev => ({ ...prev, royaltyPercentage: value }));
        } else if (selectedPaymentOption === "Other") {
            setPaymentDetails(prev => ({ ...prev, otherPaymentDescription: value }));
        }
    };

    const handleCheckboxChange = () => {
        setIsAcknowledged(!isAcknowledged);
    };
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const handleSubmit = async () => {
        // Validations
        if (!formData?.firstName.trim()) {
            toast.error("Please enter First Name.");
            return;
        }
        if (!formData?.lastName.trim()) {
            toast.error("Please enter Last Name.");
            return;
        }
        if (!formData?.userEmail.trim()) {
            toast.error("Please enter Email Address.");
            return;
        }
        if (!emailRegex.test(formData.userEmail)) {
            toast.error("Please enter Valid Email Address.");
            return;
        }
        if (!formData.phoneNo || formData.phoneNo.trim() === "") {
            toast.error("Please enter Phone Number.");
            return;
        }
        if (!formData?.streetAddress.trim()) {
            toast.error("Please enter Street Address.");
            return;
        }
        if (!formData.city.trim()) {
            toast.error("Please enter City.");
            return;
        }
        if (!formData.state.trim()) {
            toast.error("Please enter State.");
            return;
        }
        if (!formData.zipCode.trim()) {
            toast.error("Please enter Zip Code.");
            return;
        }
        if (!formData.country.trim()) {
            toast.error("Please enter Country.");
            return;
        }
        if (!selectedOption.trim()) {
            toast.error("Please select Scope of Use.");
            return;
        }
        if (selectedOption === "Other" && !otherText.trim()) {
            toast.error("Please specify 'Other' Scope of Use.");
            return;
        }
        if (!formData.requestedDate.trim()) {
            toast.error("Please select Requested Date.");
            return;
        }
        if (!selectedPaymentOption.trim()) {
            toast.error("Please select Compensation Option.");
            return;
        }
        if (selectedPaymentOption === "Flat Fee" && !paymentDetails.flatFeeAmount.trim()) {
            toast.error("Please enter Flat Fee Amount.");
            return;
        }
        if (selectedPaymentOption === "Royalties" && !paymentDetails.royaltyPercentage.trim()) {
            toast.error("Please enter Royalty Percentage.");
            return;
        }
        if (selectedPaymentOption === "Other" && !paymentDetails.otherPaymentDescription.trim()) {
            toast.error("Please describe Other Payment Details.");
            return;
        }

        if (!isAcknowledged) {
            toast.error("Please acknowledge the terms.");
            return;
        }

        const submissionData = {
            team_id:openRequest?.team_id,
            first_name: formData?.firstName,
            last_name: formData?.lastName,
            street_address: formData?.streetAddress,
            address_line_2: formData?.addressLineTwo,
            city: formData?.city,
            state: formData?.state,
            zip_code: formData?.zipCode,
            country: formData?.country,
            player_id: openRequest?.player_id,
            company_name: formData.companyName,
            email_address: formData?.userEmail,
            phone_number: formData?.phoneNo,
            business_address: formData.businessAddress,
            business_phone: formData.businessPhone,
            scope_of_use: selectedOption === "Other" ? otherText : selectedOption,
            additional_details: formData.additionalDetails,
            requested_date: formData.requestedDate,
            number_of_hours_requested: Number(formData.hoursRequested),
            flat_fees: selectedPaymentOption === "Flat Fee" ? Number(paymentDetails.flatFeeAmount) : 0,
            royalties: selectedPaymentOption === "Royalties" ? Number(paymentDetails.royaltyPercentage) : 0,
            other: selectedPaymentOption === "Other" ? paymentDetails.otherPaymentDescription : ""
        };

        if (formData.alternateDate) {
            submissionData.alternate_date = formData.alternateDate;
        }
        const url = `${APIUrl()}/v1/collaboration_requests`;
        const options = {
            method: "POST",
            headers: {
                "X-API-Key": APIUrlToken(),
            },
            data: submissionData,
            url: url,
        };

        try {
            const response = await axios(options);
            setFormData({
                firstName: "",
                lastName: "",
                companyName: "",
                // individualName: "",
                businessAddress: "",
                businessPhone: "",
                requestedDate: "",
                alternateDate: "",
                additionalDetails: "",
                userEmail: "",
                streetAddress: "",
                addressLineTwo: "",
                city: "",
                state: "",
                zipCode: "",
                country: "",
                hoursRequested: 0,
                phoneNo: ""
            });
            setSelectedOption("");
            setOtherText("");
            setSelectedPaymentOption("");
            setPaymentDetails({
                flatFeeAmount: "",
                royaltyPercentage: "",
                otherPaymentDescription: ""
            });
            setIsAcknowledged(false);
            toast.success("NIL Collaboration Request submitted successfully!");
            setOpenRequest()
        } catch (error) {
            toast.error("Error occurred while saving your data. Please try again.")
        } finally {
        }
    };
    const handleClose = () => {
        setFormData({
            firstName: "",
            lastName: "",
            companyName: "",
            individualName: "",
            businessAddress: "",
            businessPhone: "",
            requestedDate: "",
            alternateDate: "",
            additionalDetails: "",
            userEmail: "",
            streetAddress: "",
            addressLineTwo: "",
            city: "",
            state: "",
            zipCode: "",
            country: "",
            hoursRequested: 0,
            phoneNo: ""
        });
        setSelectedOption("");
        setOtherText("");
        setSelectedPaymentOption("");
        setPaymentDetails({
            flatFeeAmount: "",
            royaltyPercentage: "",
            otherPaymentDescription: ""
        });
        setIsAcknowledged(false);
        setOpenRequest()
    }
    return (
        <Modal open={openRequest?.player_id} onClose={() => handleClose()}>
            <div className="modal-container">
                <Box className="box-main-modal-for-donation"
                // sx={{
                //     width: '40vw',
                //     p: 3,
                //     bgcolor: "white",
                //     borderRadius: 2,
                //     position: "relative",
                //     height: '70vh',
                //     overflow: 'auto'

                // }}
                >
                    <IoClose
                        className="close-icon"
                        size={24}
                        onClick={() => handleClose()}
                        style={{ position: "absolute", top: 10, right: 10, cursor: "pointer" }}
                    />
                    <div>
                        <h3 className="athlete-collb-req-mdl">ATHLETE COLLABORATION REQUEST <span className="color-dc">{openRequest?.player_name}</span> ({openRequest?.team_name})</h3>
                        <p className="nicr-p">
                            This request will be reviewed by the institution's compliance office, as required by NCAA rules, state laws, 
                            and school policies. Compensation must not be tied to athletic performance, participation, or recruiting inducements 
                            to remain compliant. Additionally, any use of school logos, trademarks, or facilities requires explicit written 
                            permission from the institution. Failure to follow these guidelines may result in legal, NCAA, or institutional 
                            consequences. We look forward to supporting a transparent and compliant partnership.
                        </p>

                        <div>
                            <p className="nicr-head">1. Requestor Information </p>
                            <div className="nicr-inputs-up">
                                <div className="input-section-changepass nicr-inputs">

                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaUser />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="firstName"
                                            placeholder="First Name"
                                            value={formData.firstName}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaUser />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="lastName"
                                            placeholder="Last Name"
                                            value={formData.lastName}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>



                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <MdEmail />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="userEmail"
                                            placeholder="Email Address"
                                            value={formData.userEmail}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaPhoneAlt />
                                        </div>
                                        <input
                                            type="number"
                                            className="form-control-changepass-user"
                                            name="phoneNo"
                                            placeholder="Phone Number"
                                            value={formData.phoneNo}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>





                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaBuilding />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="companyName"
                                            placeholder="Company Name (If Applicable)"
                                            value={formData.companyName}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="streetAddress"
                                            placeholder="Street Address"
                                            value={formData.streetAddress}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="addressLineTwo"
                                            placeholder="Address Line 2"
                                            value={formData.addressLineTwo}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="city"
                                            placeholder="City"
                                            value={formData.city}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="state"
                                            placeholder="State"
                                            value={formData.state}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>

                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="zipCode"
                                            placeholder="Zip Code"
                                            value={formData.zipCode}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="country"
                                            placeholder="Country"
                                            value={formData.country}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>

                                </div>
                                {/* <div className="input-section-changepass nicr-inputs">
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaUser />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="individualName"
                                            placeholder="Individual Name"
                                            value={formData.individualName}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div> */}

                            </div>
                            {/* <div className="input-section-changepass nicr-inputs">
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaLocationDot />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="businessAddress"
                                            placeholder="Business Address"
                                            value={formData.businessAddress}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div> */}
                            {/* <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaPhoneAlt />

                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="businessPhone"
                                            placeholder="Business Phone"
                                            value={formData.businessPhone}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div> */}

                            {/* <div className="nicr-inputs-up">
                                <div className="input-section-changepass nicr-inputs">
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <MdEmail />
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control-changepass-user"
                                            name="userEmail"
                                            placeholder="Email Address"
                                            value={formData.userEmail}
                                            onChange={handleInputChange}
                                            autoComplete="off"
                                        />
                                    </div>
                                </div>
                                <div className="input-section-changepass nicr-inputs"></div>
                            </div> */}

                        </div>

                        <div>
                            <p className="nicr-head">2. Purpose of Request</p>
                            <p className="nicr-p2">The Company is requesting the right to use the Athlete’s NIL in the following ways:</p>
                            <div>
                                {options.map((option) => (
                                    <div key={option}>
                                        <label className="nicr-label">
                                            <input
                                                type="radio"
                                                name="option"
                                                value={option}
                                                checked={selectedOption === option}
                                                onChange={() => handleOptionChange(option)}
                                            />
                                            {option}
                                        </label>
                                        {option === "Other" && selectedOption === "Other" && (
                                            <div style={{ marginTop: "8px" }}>
                                                <input
                                                    type="text"
                                                    className="form-control-changepass-user"
                                                    style={{ width: "50%" }}
                                                    placeholder="Please specify..."
                                                    value={otherText}
                                                    onChange={(e) => setOtherText(e.target.value)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="nicr-addtnl">
                            <div className="nicr-add-head">
                                Additional Details
                            </div>
                            <textarea
                                className="nicr-add-area"
                                name="additionalDetails"
                                placeholder="Message"
                                value={formData.additionalDetails}
                                onChange={handleInputChange}
                                autoComplete="off"
                            />
                        </div>
                        <div>
                            <p className="nicr-head">3. Date(s) Requested:</p>
                            <div className="nicr-inputs-up">
                                <div className="input-section-changepass nicr-inputs">
                                    Requested Date
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaCalendarAlt />

                                        </div>
                                        <input
                                            type="date"
                                            className="form-control-changepass-user"
                                            name="requestedDate"
                                            value={formData.requestedDate}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                <div className="input-section-changepass nicr-inputs">
                                    Alternate Date
                                    <div className="input-group-changepass nicr-inside-icon">
                                        <div className="input-icon-changepass">
                                            <FaCalendarAlt />

                                        </div>
                                        <input
                                            type="date"
                                            className="form-control-changepass-user"
                                            name="alternateDate"
                                            value={formData.alternateDate}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div>

                        </div>
                        <p className="nicr-head">4. Number of Hours Requested</p>
                        <div className="input-group-changepass nicr-inside-icon"
                        style={{ marginBottom: '16px' }} >
                            <div className="input-icon-changepass">
                                <MdOutlineAccessTimeFilled />

                            </div>
                            <input
                                type="number"
                                className="form-control-changepass-user"
                                placeholder="Number of hours requested"
                                name="hoursRequested"
                                value={formData.hoursRequested}
                                onChange={handleInputChange}
                            />
                        </div>
                        <div>
                            <p className="nicr-head">5. Compensation</p>
                            <p className="nicr-p2">The Athlete will receive the following in exchange for use of NIL:</p>

                            {/* Flat Fee Option */}
                            <div>
                                <label className="nicr-label">
                                    <input
                                        type="radio"
                                        name="payment"
                                        value="Flat Fee"
                                        checked={selectedPaymentOption === "Flat Fee"}
                                        onChange={() => handlePaymentOptionChange("Flat Fee")}
                                    />
                                    Flat Fee: $
                                </label>
                                {selectedPaymentOption === "Flat Fee" && (
                                    <input
                                        type="number"
                                        placeholder="Enter flat fee amount"
                                        value={paymentDetails.flatFeeAmount}
                                        onChange={handlePaymentInputChange}
                                        className="form-control-changepass-user"
                                        style={{ marginTop: "8px" }}
                                    />
                                )}
                            </div>

                            {/* Royalties Option */}
                            <div className="three-opts-modal-nillcolb">
                                <label className="nicr-label">
                                    <input
                                        type="radio"
                                        name="payment"
                                        value="Royalties"
                                        checked={selectedPaymentOption === "Royalties"}
                                        onChange={() => handlePaymentOptionChange("Royalties")}
                                    />
                                    Royalties:
                                </label>
                                {selectedPaymentOption === "Royalties" && (
                                    <input
                                        type="number"
                                        placeholder="Enter % of net revenue"
                                        value={paymentDetails.royaltyPercentage}
                                        onChange={handlePaymentInputChange}
                                        className="form-control-changepass-user"
                                        style={{ marginTop: "8px" }}
                                    />
                                )}
                            </div>

                            {/* Other Option */}
                            <div className="three-opts-modal-nillcolb">
                                <label className="nicr-label">
                                    <input
                                        type="radio"
                                        name="payment"
                                        value="Other"
                                        checked={selectedPaymentOption === "Other"}
                                        onChange={() => handlePaymentOptionChange("Other")}
                                    />
                                    Other:
                                </label>
                                {selectedPaymentOption === "Other" && (
                                    <input
                                        type="text"
                                        placeholder="Please specify other payment details"
                                        value={paymentDetails.otherPaymentDescription}
                                        onChange={handlePaymentInputChange}
                                        className="form-control-changepass-user"
                                        style={{ marginTop: "8px" }}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="nicr-cb">
                            <input
                                type="checkbox"
                                checked={isAcknowledged}
                                onChange={handleCheckboxChange}
                            />
                            <label>
                                {" "}
                                By selecting this box, you acknowledge and agree that this document, form, or communication is for informational purposes only and does not constitute a binding legal contract, agreement, or obligation between the parties. No legal rights, responsibilities, or liabilities are created, intended, or implied by this acknowledgment.
                            </label>
                        </div>
                        {/* <div className="button-section-changepass-user">
                            <button onClick={handleSubmit}>
                                {"Submit"}
                            </button>
                        </div> */}
                        <div className="buttons-cards-modal">
                            <Button className="submit-modal-card" onClick={handleSubmit}>
                                Submit
                            </Button>
                            <Button className="cancel-button-modal" onClick={() => handleClose()}>
                                Cancel
                            </Button>
                        </div>
                    </div>
                </Box>
            </div>
        </Modal>

    );
};
